<template>
  <div>
    <BrTimeStatusFilter @change="handleChange" />
    <BrTimeDistribution ref="baseCountCardProductRef" :data="tableData" :filter-form="filterForm" style="margin-top: 18px" />
    <BrTimeDistributionTable :data="tableData" :filter-form="filterForm" style="margin-top: 18px" />
  </div>
</template>

<script>
import BrTimeStatusFilter from './components/BrTimeStatusFilter.vue';
import BrTimeDistribution from './components/BrTimeDistribution.vue';
import { getBrStatusTimeCollecter } from '@/api/business/requirement';
import BrTimeDistributionTable from './components/BrTimeDistributionTable.vue';
import moment from 'moment';

export default {
  components: { BrTimeStatusFilter, BrTimeDistribution, BrTimeDistributionTable },
  data() {
    return {
      orgTableData: [],
      tableData: [],
      brRetrospectMap: {},
      filterForm: {
        searchTimeType: 135,
        percent: 100,
        startTime: '',
        endTime: ''
      },
      stepMaping: [{}]
    };
  },
  computed: {},
  created() {
    // this.getRetData();
  },
  methods: {
    handleChange(form) {
      this.filterForm = form;
      this.getRetData();
    },
    buildData(data) {
      const _tableData = [];
      const percent = this.filterForm.percent;
      // 清洗数据
      const grouped = data.reduce((acc, item) => {
        const key = item.months;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      // 组装成list
      for (const key in grouped) {
        const tableItem = {
          months: key
        };
        const _item = grouped[key];
        // 需要根据percent来过滤数据
        // if (_item && _item.length > 0 && percent !== 100) {
        //   // 取总数的百分之percent的那条数据
        //   const _index = Math.floor(_item.length * percent / 100);
        //   console.log('_item', _item, _index);
        //   _item = [_item[_index]];
        // }

        // console.log('_item', _item);
        const group1 = _item.reduce((acc, item) => {
          const key1 = item.afterStep; // 按照这个分组
          if (!acc[key1]) {
            acc[key1] = { timeCount: 0, total: 0, datas: [] };
          }
          acc[key1].timeCount += item.timeCount;
          acc[key1].total += 1;
          acc[key1].datas.push(item);
          return acc;
        }, {});
        for (const key2 in group1) {
          // 这里的key2是每个afterStep的值，也就是每个阶段的值
          const statusGroup = group1[key2];

          if (percent === 100) {
            // 这里计算每个阶段的平均时间
            tableItem[key2] = (statusGroup.timeCount / statusGroup.total / 60 / 60 / 24).toFixed(2);
          } else {
            // 这里或者每个阶段是p值
            const _index = Math.floor((statusGroup.datas.length * percent) / 100);
            tableItem[key2] = (statusGroup.datas[_index].timeCount / 60 / 60 / 24).toFixed(2);
          }
        }
        _tableData.push(tableItem);
      }
      return _tableData;
    },
    getRetData() {
      getBrStatusTimeCollecter(this.filterForm).then(res => {
        const _data = res.data || [];
        this.orgTableData = _data;
        this.tableData = this.buildData(_data);
        this.$nextTick(() => {
          this.$refs.baseCountCardProductRef.getData(this.tableData, this.orgTableData);
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
